import type { DemoManifest } from "../../types";

export const GASTRONOMY_GENERIC_DRAFT_DEMO: DemoManifest = Object.freeze({
  id: "gastronomy.generic-draft",
  name: "ClickDialog Gastronomía — Demo genérica",
  vertical: "Gastronomía",
  industryKey: "gastronomy",
  industryLabel: "Gastronomy",
  nicheKey: "generic",
  nicheLabel: "Generic gastronomy",
  solutionKey: "composition-exploration",
  solutionLabel: "Composition Exploration",
  demoType: "module",
  maturity: "experimental",
  runtimeStatus: "requires-organization",
  status: "stable-draft",
  statusLabel: "Borrador estable",
  summary: "Exploración amplia de capacidades gastronómicas. Combina superficies visuales con un sandbox funcional aislado para Pedidos, Cocina/KDS e Inventario.",
  scopeLabel: "Demo genérica · uso interno/comercial guiado",
  capabilities: Object.freeze([
    "Navegación amplia de capacidades",
    "Pedidos funcionales en sandbox",
    "Producción / KDS funcional",
    "Inventario funcional con consumo por receta",
    "Reset determinista",
  ]),
  launch: Object.freeze({ kind: "organization-gastro-alias" }),
});
